export default __webpack_public_path__ + "static/sri-7d7b193b87322deb38c6ae799bc20c11.webp";